module.exports = __webpack_public_path__ + "static/img/codestore.255cca6.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/works/codestore.jpeg
// module id = vyIG
// module chunks = 0